// Textos do Toxicológico (31/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.tox.titulo': 'Toxicológico',
    'dp.tox.comoFunciona': 'Quem está sujeito é motorista ou tem CNH {{toxCategorias}} no cadastro. O que conta é a data da coleta: admissão e desligamento valem {{toxValidadeDias}} dias, e o periódico vence {{toxPeriodicoMeses}} meses depois, só para quem tem menos de {{toxIdade}} anos. Para a escala, vencido é vencido no dia. O resultado não é guardado; o relatório do médico revisor é dado de saúde e só abre para quem vê dado sensível do DP.',
    'dp.tox.situacao.vencido': 'Vencido',
    'dp.tox.situacao.sem_exame': 'Sem exame',
    'dp.tox.situacao.vence_60': 'Vence em {{toxAvisoDias}} dias',
    'dp.tox.situacao.em_dia': 'Em dia',
    'dp.tox.situacao.isento': 'Isento pela idade',
    'dp.tox.kpi.escaladosVencido': 'Escalados com toxicológico vencido',
    'dp.tox.finalidade': 'Finalidade',
    'dp.tox.finalidade.admissao': 'Admissão',
    'dp.tox.finalidade.desligamento': 'Desligamento',
    'dp.tox.finalidade.periodico': 'Periódico',
    'dp.tox.col.periodico': 'Periódico',
    'dp.tox.col.admissao': 'Admissão',
    'dp.tox.col.escala': 'Escala',
    'dp.tox.proximoPeriodico': 'Próximo periódico {{data}}',
    'dp.tox.ultimaColeta': 'Última coleta {{data}}',
    'dp.tox.admissaoValida': 'Válido até {{data}}',
    'dp.tox.admissaoVencida': 'Venceu em {{data}}',
    'dp.tox.semAdmissao': 'Sem exame de admissão',
    'dp.tox.cnh': 'CNH {{categoria}}',
    'dp.tox.idade': '{{anos}} anos',
    'dp.tox.escaladoHoje': 'Escalado hoje',
    'dp.tox.escaladoAmanha': 'Escalado amanhã',
    'dp.tox.registrar': 'Registrar exame',
    'dp.tox.detalhe': 'Detalhe do exame',
    'dp.tox.registrarTitulo': 'Exame toxicológico de {{nome}}',
    'dp.tox.registrarNovoTitulo': 'Registrar exame toxicológico',
    'dp.tox.corrigirTitulo': 'Corrigir o exame de {{nome}}',
    'dp.tox.matricula': 'Matrícula',
    'dp.tox.dataColeta': 'Data da coleta',
    'dp.tox.dataRelatorio': 'Data do relatório',
    'dp.tox.laboratorio': 'Laboratório',
    'dp.tox.laboratorioCnpj': 'CNPJ do laboratório',
    'dp.tox.numeroExame': 'Número do exame',
    'dp.tox.medicoRevisor': 'Médico revisor',
    'dp.tox.medicoCrm': 'CRM',
    'dp.tox.validoAte': 'Válido até',
    'dp.tox.relatorio': 'Relatório do médico revisor',
    'dp.tox.relatorioEscolher': 'Escolher o relatório',
    'dp.tox.relatorioRegra': 'PDF, JPG, PNG, DOCX ou XLSX, até 5 MB. O laudo detalhado do laboratório nunca entra aqui.',
    'dp.tox.relatorioTirar': 'Tirar o arquivo',
    'dp.tox.relatorioAnexar': 'Anexar relatório',
    'dp.tox.relatorioTrocar': 'Trocar o relatório',
    'dp.tox.relatorioAbrir': 'Abrir relatório',
    'dp.tox.relatorioAnexado': 'Relatório anexado.',
    'dp.tox.relatorioSemRelatorio': 'Sem relatório anexado',
    'dp.tox.relatorioSensivel': 'O relatório é dado de saúde: só quem vê dado sensível do DP o abre.',
    'dp.tox.relatorioRecusa.extensao': 'Formato não aceito',
    'dp.tox.relatorioRecusa.legado': 'Salve como PDF, DOCX ou XLSX',
    'dp.tox.relatorioRecusa.tamanho': 'Passa de 5 MB',
    'dp.tox.relatorioRecusa.vazio': 'Arquivo vazio',
    'dp.tox.exameRegistrado': 'Exame registrado.',
    'dp.tox.exameRegistradoSemAnexo': 'Exame registrado, mas o relatório não subiu: {{erro}}',
    'dp.tox.corrigir': 'Corrigir',
    'dp.tox.semExameRegistrado': 'Esta pessoa ainda não tem exame registrado no Hub.',
    'dp.tox.semExameParaTratativa': 'A cobrança fica registrada quando houver um exame no Hub.',
    'dp.tox.cobrancaTitulo': 'Cobrar o toxicológico de {{nome}}',
    'dp.tox.cobrancaTexto': 'Cobrança do exame toxicológico pelo WhatsApp.',
    'dp.tox.mudadoPor': 'Alterado por {{quem}}',
  },
  en: {
    'dp.tox.titulo': 'Drug testing',
    'dp.tox.comoFunciona': 'Drivers and anyone with a {{toxCategorias}} license are subject to it. The collection date is what counts: hiring and termination tests last {{toxValidadeDias}} days, and the periodic test expires {{toxPeriodicoMeses}} months later, only for people under {{toxIdade}}. For scheduling, expired is expired on the day. The result is not stored; the reviewing physician report is health data and only opens for whoever sees sensitive HR data.',
    'dp.tox.situacao.vencido': 'Expired',
    'dp.tox.situacao.sem_exame': 'No test',
    'dp.tox.situacao.vence_60': 'Expires within {{toxAvisoDias}} days',
    'dp.tox.situacao.em_dia': 'Valid',
    'dp.tox.situacao.isento': 'Exempt by age',
    'dp.tox.kpi.escaladosVencido': 'Scheduled with expired test',
    'dp.tox.finalidade': 'Purpose',
    'dp.tox.finalidade.admissao': 'Hiring',
    'dp.tox.finalidade.desligamento': 'Termination',
    'dp.tox.finalidade.periodico': 'Periodic',
    'dp.tox.col.periodico': 'Periodic',
    'dp.tox.col.admissao': 'Hiring',
    'dp.tox.col.escala': 'Schedule',
    'dp.tox.proximoPeriodico': 'Next periodic {{data}}',
    'dp.tox.ultimaColeta': 'Last collection {{data}}',
    'dp.tox.admissaoValida': 'Valid until {{data}}',
    'dp.tox.admissaoVencida': 'Expired on {{data}}',
    'dp.tox.semAdmissao': 'No hiring test',
    'dp.tox.cnh': 'License {{categoria}}',
    'dp.tox.idade': '{{anos}} years old',
    'dp.tox.escaladoHoje': 'Scheduled today',
    'dp.tox.escaladoAmanha': 'Scheduled tomorrow',
    'dp.tox.registrar': 'Record test',
    'dp.tox.detalhe': 'Test details',
    'dp.tox.registrarTitulo': 'Drug test of {{nome}}',
    'dp.tox.registrarNovoTitulo': 'Record a drug test',
    'dp.tox.corrigirTitulo': 'Correct the test of {{nome}}',
    'dp.tox.matricula': 'Employee ID',
    'dp.tox.dataColeta': 'Collection date',
    'dp.tox.dataRelatorio': 'Report date',
    'dp.tox.laboratorio': 'Laboratory',
    'dp.tox.laboratorioCnpj': 'Laboratory tax ID',
    'dp.tox.numeroExame': 'Test number',
    'dp.tox.medicoRevisor': 'Reviewing physician',
    'dp.tox.medicoCrm': 'Medical license',
    'dp.tox.validoAte': 'Valid until',
    'dp.tox.relatorio': 'Reviewing physician report',
    'dp.tox.relatorioEscolher': 'Choose the report',
    'dp.tox.relatorioRegra': 'PDF, JPG, PNG, DOCX or XLSX, up to 5 MB. The detailed lab report never goes here.',
    'dp.tox.relatorioTirar': 'Remove the file',
    'dp.tox.relatorioAnexar': 'Attach report',
    'dp.tox.relatorioTrocar': 'Replace the report',
    'dp.tox.relatorioAbrir': 'Open report',
    'dp.tox.relatorioAnexado': 'Report attached.',
    'dp.tox.relatorioSemRelatorio': 'No report attached',
    'dp.tox.relatorioSensivel': 'The report is health data: only whoever sees sensitive HR data opens it.',
    'dp.tox.relatorioRecusa.extensao': 'Format not accepted',
    'dp.tox.relatorioRecusa.legado': 'Save as PDF, DOCX or XLSX',
    'dp.tox.relatorioRecusa.tamanho': 'Over 5 MB',
    'dp.tox.relatorioRecusa.vazio': 'Empty file',
    'dp.tox.exameRegistrado': 'Test recorded.',
    'dp.tox.exameRegistradoSemAnexo': 'Test recorded, but the report did not upload: {{erro}}',
    'dp.tox.corrigir': 'Correct',
    'dp.tox.semExameRegistrado': 'This person has no test recorded in the Hub yet.',
    'dp.tox.semExameParaTratativa': 'The follow-up is logged once there is a test in the Hub.',
    'dp.tox.cobrancaTitulo': 'Ask {{nome}} for the drug test',
    'dp.tox.cobrancaTexto': 'Asked for the drug test on WhatsApp.',
    'dp.tox.mudadoPor': 'Changed by {{quem}}',
  },
  es: {
    'dp.tox.titulo': 'Toxicológico',
    'dp.tox.comoFunciona': 'Está sujeto quien es conductor o tiene licencia {{toxCategorias}} en el registro. Lo que cuenta es la fecha de la toma: admisión y desvinculación valen {{toxValidadeDias}} días, y el periódico vence {{toxPeriodicoMeses}} meses después, solo para menores de {{toxIdade}} años. Para la escala, vencido es vencido en el día. El resultado no se guarda; el informe del médico revisor es dato de salud y solo lo abre quien ve datos sensibles del DP.',
    'dp.tox.situacao.vencido': 'Vencido',
    'dp.tox.situacao.sem_exame': 'Sin examen',
    'dp.tox.situacao.vence_60': 'Vence en {{toxAvisoDias}} días',
    'dp.tox.situacao.em_dia': 'Al día',
    'dp.tox.situacao.isento': 'Exento por la edad',
    'dp.tox.kpi.escaladosVencido': 'Escalados con toxicológico vencido',
    'dp.tox.finalidade': 'Finalidad',
    'dp.tox.finalidade.admissao': 'Admisión',
    'dp.tox.finalidade.desligamento': 'Desvinculación',
    'dp.tox.finalidade.periodico': 'Periódico',
    'dp.tox.col.periodico': 'Periódico',
    'dp.tox.col.admissao': 'Admisión',
    'dp.tox.col.escala': 'Escala',
    'dp.tox.proximoPeriodico': 'Próximo periódico {{data}}',
    'dp.tox.ultimaColeta': 'Última toma {{data}}',
    'dp.tox.admissaoValida': 'Válido hasta {{data}}',
    'dp.tox.admissaoVencida': 'Venció el {{data}}',
    'dp.tox.semAdmissao': 'Sin examen de admisión',
    'dp.tox.cnh': 'Licencia {{categoria}}',
    'dp.tox.idade': '{{anos}} años',
    'dp.tox.escaladoHoje': 'Escalado hoy',
    'dp.tox.escaladoAmanha': 'Escalado mañana',
    'dp.tox.registrar': 'Registrar examen',
    'dp.tox.detalhe': 'Detalle del examen',
    'dp.tox.registrarTitulo': 'Examen toxicológico de {{nome}}',
    'dp.tox.registrarNovoTitulo': 'Registrar examen toxicológico',
    'dp.tox.corrigirTitulo': 'Corregir el examen de {{nome}}',
    'dp.tox.matricula': 'Matrícula',
    'dp.tox.dataColeta': 'Fecha de la toma',
    'dp.tox.dataRelatorio': 'Fecha del informe',
    'dp.tox.laboratorio': 'Laboratorio',
    'dp.tox.laboratorioCnpj': 'CNPJ del laboratorio',
    'dp.tox.numeroExame': 'Número del examen',
    'dp.tox.medicoRevisor': 'Médico revisor',
    'dp.tox.medicoCrm': 'CRM',
    'dp.tox.validoAte': 'Válido hasta',
    'dp.tox.relatorio': 'Informe del médico revisor',
    'dp.tox.relatorioEscolher': 'Elegir el informe',
    'dp.tox.relatorioRegra': 'PDF, JPG, PNG, DOCX o XLSX, hasta 5 MB. El informe detallado del laboratorio nunca entra aquí.',
    'dp.tox.relatorioTirar': 'Quitar el archivo',
    'dp.tox.relatorioAnexar': 'Adjuntar informe',
    'dp.tox.relatorioTrocar': 'Cambiar el informe',
    'dp.tox.relatorioAbrir': 'Abrir informe',
    'dp.tox.relatorioAnexado': 'Informe adjuntado.',
    'dp.tox.relatorioSemRelatorio': 'Sin informe adjunto',
    'dp.tox.relatorioSensivel': 'El informe es dato de salud: solo lo abre quien ve datos sensibles del DP.',
    'dp.tox.relatorioRecusa.extensao': 'Formato no aceptado',
    'dp.tox.relatorioRecusa.legado': 'Guarde como PDF, DOCX o XLSX',
    'dp.tox.relatorioRecusa.tamanho': 'Pasa de 5 MB',
    'dp.tox.relatorioRecusa.vazio': 'Archivo vacío',
    'dp.tox.exameRegistrado': 'Examen registrado.',
    'dp.tox.exameRegistradoSemAnexo': 'Examen registrado, pero el informe no subió: {{erro}}',
    'dp.tox.corrigir': 'Corregir',
    'dp.tox.semExameRegistrado': 'Esta persona aún no tiene examen registrado en el Hub.',
    'dp.tox.semExameParaTratativa': 'El cobro queda registrado cuando haya un examen en el Hub.',
    'dp.tox.cobrancaTitulo': 'Cobrar el toxicológico de {{nome}}',
    'dp.tox.cobrancaTexto': 'Cobro del examen toxicológico por WhatsApp.',
    'dp.tox.mudadoPor': 'Modificado por {{quem}}',
  },
}
